// src/components/TopDownBoard.tsx
//
// "Top-down organization" — headline on the left, a rich, detailed app-board
// mockup on the right (columns of real-looking application cards with match
// scores, status tags, and progress bars), plus a floating AI-insight chip.
// Matched to the reference's TOP-DOWN ORGANIZATION section, kept in the dark
// neon theme. Entrance uses the page's global `.reveal` observer.
import React from "react";
import "../styles/TopDownBoard.css";

type Card = { a: string; av: string; co: string; role: string; tag: string; pct: number; tagC: string };

const BOARD: { title: string; n: number; cards: Card[] }[] = [
  {
    title: "Applied",
    n: 3,
    cards: [
      { a: "L", av: "#5e6ad2", co: "Linear", role: "Design Engineer", tag: "AI Matched 92%", pct: 92, tagC: "#6366f1" },
      { a: "F", av: "#f24e1e", co: "Figma", role: "Product Designer", tag: "Auto-Tracked", pct: 60, tagC: "#22d3ee" },
      { a: "R", av: "#3d5afe", co: "Retool", role: "Frontend", tag: "Referral", pct: 40, tagC: "#a855f7" },
    ],
  },
  {
    title: "Interview",
    n: 2,
    cards: [
      { a: "S", av: "#635bff", co: "Stripe", role: "Senior Frontend", tag: "Onsite · Tomorrow", pct: 75, tagC: "#22d3ee" },
      { a: "V", av: "#0f172a", co: "Vercel", role: "UI Engineer", tag: "Tech Round", pct: 66, tagC: "#a855f7" },
    ],
  },
  {
    title: "Offer & Done",
    n: 2,
    cards: [
      { a: "Pe", av: "#20808d", co: "Perplexity", role: "Product", tag: "$165k Offer", pct: 100, tagC: "#34d399" },
      { a: "N", av: "#0f172a", co: "Notion", role: "Designer", tag: "Negotiating", pct: 88, tagC: "#34d399" },
    ],
  },
];

const TopDownBoard: React.FC = () => (
  <section className="tdb">
    <div className="lp-wrap tdb-grid">
      {/* Copy */}
      <div className="tdb-copy reveal">
        <span className="tdb-eyebrow">Top-down organization</span>
        <h2 className="tdb-title">
          Organization that works{" "}
          <span className="tdb-accent">as hard as</span> you do
        </h2>
        <p className="tdb-sub">
          See your entire hunt from above. No scattered sheets, no lost emails —
          just one living board that mirrors your momentum.
        </p>
      </div>

      {/* Board mockup */}
      <div className="tdb-board reveal">
        <div className="tdb-board-head">
          <span className="tdb-board-avatar">S</span>
          <span className="tdb-board-titles">
            <span className="tdb-board-name">My Job Hunt · Q1</span>
            <span className="tdb-board-meta">18 active · 4 interviews</span>
          </span>
          <span className="tdb-board-add">+ New</span>
        </div>

        <div className="tdb-cols">
          {BOARD.map((col) => (
            <div className="tdb-col" key={col.title}>
              <div className="tdb-col-head">
                <span>{col.title}</span>
                <span className="tdb-col-n">{col.n}</span>
              </div>
              {col.cards.map((c, i) => (
                <div className="tdb-card" key={i}>
                  <div className="tdb-card-top">
                    <span className="tdb-card-av" style={{ background: c.av }}>
                      {c.a}
                    </span>
                    <span className="tdb-card-titles">
                      <span className="tdb-card-co">{c.co}</span>
                      <span className="tdb-card-role">{c.role}</span>
                    </span>
                  </div>
                  <span className="tdb-card-tag" style={{ ["--t" as string]: c.tagC }}>
                    {c.tag}
                  </span>
                  <span className="tdb-card-bar">
                    <i style={{ width: `${c.pct}%`, background: c.tagC }} />
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>

        <div className="tdb-insight">
          <span className="tdb-insight-label">AI insight</span>
          You follow up <b>3× faster</b> than average. Keep it up!
        </div>
      </div>
    </div>
  </section>
);

export default TopDownBoard;
